import { render } from "./AddNew.vue?vue&type=template&id=6b13d449"
import script from "./AddNew.vue?vue&type=script&lang=js"
export * from "./AddNew.vue?vue&type=script&lang=js"

import "./AddNew.vue?vue&type=style&index=0&id=6b13d449&lang=css"
script.render = render

export default script